import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import entities from './entities'

export default function createReducer(injectedReducers = {}, history) {
  return combineReducers({
    router: connectRouter(history),
    entities,
    ...injectedReducers
  })
}
